/*global Ractive, RedmarineUXTemplates, BaseComponent */

// Add component to Global Ractive object
Ractive.components['ux-radiogroup'] = BaseComponent.extend({

	template: RedmarineUXTemplates.uxradiogroupUxradiogroup,

	events: {
		uparrow: RactiveEventsKeys.uparrow,
		downarrow: RactiveEventsKeys.downarrow,
		leftarrow: RactiveEventsKeys.leftarrow,
		rightarrow: RactiveEventsKeys.rightarrow,
		enter: RactiveEventsKeys.enter,
		space: RactiveEventsKeys.space
	},

	// any default data
	data: {
		component: 'ux-radiogroup'
	},

	toTheLeft: function(groupOfItems, itemIndex, firstIndex, lastIndex) {
		itemIndex -= 1;
		if (itemIndex < firstIndex) {
			itemIndex = lastIndex;
		}
		return itemIndex;
	},

	toTheRight: function(groupOfItems, itemIndex, firstIndex, lastIndex) {
		itemIndex += 1;
		if (itemIndex > lastIndex) {
			itemIndex = firstIndex;
		}
		return itemIndex;
	},

	navigate: function(event, left) {
		event.original.preventDefault();

		var groupOfItems = this.findAll('*[role="radio"]');

		var itemIndex = this.get('itemIndex');

		if (!itemIndex && itemIndex !== 0) {
			// first time focus on the selected or failing that the first element
			var selectedItem = this.find('*[aria-checked="true"]');
			if (selectedItem) {
				itemIndex = _.findIndex(groupOfItems, function(item) {
					return selectedItem === item;
				});
			} else {
				itemIndex = 0;
			}
		} else {
			// use the current position to control the tab
			var firstIndex = 0,
				lastIndex = groupOfItems.length - 1;
			if (left) {
				itemIndex = this.toTheLeft(groupOfItems, itemIndex, firstIndex, lastIndex);
			} else {
				itemIndex = this.toTheRight(groupOfItems, itemIndex, firstIndex, lastIndex);
			}
		}

		this.set('itemIndex', itemIndex);
		groupOfItems[itemIndex].focus();
	},

	onrender: function() {
		var self = this;

		this.on('navigateLeft', function (event) {
			self.navigate(event, true);
			return false;
		});

		this.on('navigateRight', function (event) {
			self.navigate(event, false);
			return false;
		});

		/*
		 * ensure the first arrow key press will go to the selected radio button
		 */
		this.on('focus', function (event) {
			this.set('itemIndex', null);
			return false;
		});

		/*
		 * set the item index
		 * if not disabled then fire the event defined in the context
		 * event.context.value should provide the information needed to process the event
		 */
		this.on('select', function (event) {
			event.original.preventDefault();

			this.set('itemIndex', event.context.itemIndex);

			if (!event.context.disabled && event.context.fireEvent) {
				self.fire(event.context.fireEvent, event);
			}
			return false;
		});
	}
});
